import { render } from "./PLShoppingCart.vue?vue&type=template&id=a668c4fc"
import script from "./PLShoppingCart.vue?vue&type=script&lang=js"
export * from "./PLShoppingCart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__